<template>
  <div>
    <TreeNode
      :node="compTree"
      :loading="loading"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
import TreeNode from '../ui/TreeNode.vue'

export default {
  name: 'ComponentTree',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    components: {
      type: Array,
      default: () => ([])
    },
    currentComponent: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TreeNode
  },
  computed: {
    compTree () {
      const childPopulate = (cmps, node, pid) => {
        const children = ((node && node.deps) || []).map((depId) => {
          const depNode = cmps?.find((c) => c?.old_id === depId);
          return childPopulate(cmps, depNode, node?.old_id);
        });
        return {
          ...node,
          selected:
            this.currentComponent && this.currentComponent?.old_id === node?.old_id,
          children,
          pid,
        };
      }

      const appNode = this.components?.find(c => c?.name === 'app')
      return appNode ? childPopulate(this.components, appNode, null) : {}
    }
  },
}
</script>
